import React from 'react'
import {
    Box,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'

import { Attribute, RentRollRow } from '../../types'

interface RentRollTableProps {
    rows: RentRollRow[]
    attributes: Attribute[]
    sortColumn: string | null
    setSortColumn: (columnName: string) => void
    isLoading: boolean
    classes: ClassNameMap<string>
}

export const RentRollTable: React.FC<RentRollTableProps> = ({
    rows,
    attributes,
    sortColumn,
    setSortColumn,
    isLoading,
    classes,
}) => {
    const columnCount = Math.max(attributes.length, 1)

    return (
        <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        {attributes.map((attr) => (
                            <TableCell
                                key={attr.id}
                                className={classes.headerCell}
                                onClick={() => setSortColumn(attr.name)}
                            >
                                <Box display="flex" alignItems="center">
                                    <span>{attr.name}</span>
                                    {sortColumn === attr.name && (
                                        <span style={{ marginLeft: 4 }}>
                                            {'↓'}
                                        </span>
                                    )}
                                </Box>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isLoading ? (
                        <TableRow>
                            <TableCell colSpan={columnCount}>
                                <Box
                                    display="flex"
                                    justifyContent="flex-start"
                                    py={4}
                                    px={30}
                                >
                                    <CircularProgress />
                                </Box>
                            </TableCell>
                        </TableRow>
                    ) : rows.length > 0 ? (
                        rows.map((row) => (
                            <TableRow key={row.id} hover>
                                {attributes.map((attr) => (
                                    <TableCell
                                        key={`${row.id}-${attr.name}`}
                                        className={classes.cell}
                                    >
                                        {row.values[attr.name]?.value ?? '-'}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={columnCount}>
                                <Box
                                    display="flex"
                                    justifyContent="flex-start"
                                    py={4}
                                >
                                    <Typography variant="body1">
                                        No rent roll data found
                                    </Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
